import { Object3D } from "three"

export const dummyObject3D = new Object3D()

export const {
  matrix: dummyMatrix,
  position: dummyPosition,
  rotation: dummyRotation,
  quaternion: dummyQuaternion,
  scale: dummyScale,
} = dummyObject3D

export function resetDummyObject3D() {
  dummyObject3D.position.set(0, 0, 0)
  dummyObject3D.rotation.set(0, 0, 0)
  dummyObject3D.quaternion.set(0, 0, 0, 1)
  dummyObject3D.scale.set(1, 1, 1)
}